import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { DomainData } from 'src/app/model/domain-data';
import { autocompleteValidator } from 'src/app/utils/validators';

@Component({
  selector: 'insert-edit-autocomplete',
  templateUrl: './autocomplete.component.html',
  viewProviders: [
    { provide: ControlContainer, useExisting: FormGroupDirective }
  ]
})
export class AutocompleteComponent implements OnInit, OnChanges {
  @Input() fieldName!: string;
  @Input() label!: string;
  @Input() domain!: DomainData[];
  @Input() required: boolean = false;

  @Output() selected: EventEmitter<DomainData> = new EventEmitter<DomainData>();

  filteredOptions!: Observable<DomainData[]>;

  constructor(private formGroupDirective: FormGroupDirective) {}

  ngOnInit(): void {
    this.filteredOptions = this.getFormControlField()?.valueChanges.pipe(
      startWith(''),
      map(value => typeof value === 'string' ? value : null),
      map(data => this._filter(data)),
      map(list => list.slice(0, 100)) //Limit result set to 100 elements
    ) as Observable<DomainData[]>;
  }

  ngOnChanges(changes: SimpleChanges) {
    if(!!changes['domain']) {
      this.getFormControlField()?.setValidators(autocompleteValidator(changes['domain'].currentValue));
      this.getFormControlField()?.updateValueAndValidity();
      
      if(!!this.getFormControlField()?.getError('invalid')) {
        this.getFormControlField()?.patchValue(undefined);
        this.getFormControlField()?.updateValueAndValidity();
      }
    }
  }

  private _filter(value: string | null): DomainData[] {
    var result = this.domain;

    if(!!value) {
      result = result.filter(option => option.value.toLowerCase().includes(value.toLowerCase()));
    }

    return result;
  }

  getFormControlField() {
    return this.formGroupDirective.form.get(this.fieldName);
  }

  displayAutocompleteField(element: DomainData): string {
    return element?.value;
  }

  onSelect(value: DomainData) {
    this.selected.emit(value);
  }
}
